<template>
<div class="initiatives-page fill-height d-flex flex-column-reverse flex-md-row" @wheel="handleWheel">
  <section v-show="Initiatives" class="info-viewer fill-height relative d-flex flex-column">
    <div class="side-menu fill-height">
      <span class="handler" @click="handleSideMenuClick" @mouseenter="handleSideEnter" @mouseleave="handleSideLeave" data-cursor-target="center center">
        <lottie  :options="defaultOptions" :height="80" :width="80" v-on:animCreated="handleAnimation"/>
      </span>
    </div>
    <transition name="side-scroll">
      <InitiativesSideScroll
        v-if="isSideScrollVisible"
        :projects="Initiatives.items"
        class="side-scroll"/>
    </transition>
    <transition name="current-index" appear mode="out-in">
      <span :key="currentImageIndex" class="currentIndex">{{currentImageIndex}}</span>
    </transition>
    <div class="ml-10 ml-sm-32 content">
          <transition name="name-transition" mode="out-in">
            <span v-if="!isViewAll && Initiatives" :key="currentProjectsName" class="projectName mb-4">{{currentProjectsName}}</span>
          </transition>
          <transition appear name="title-transition" mode="out-in">
            <h1 v-if="isViewAll" class="viewAll" v-html="Splitting.html({content: $root.siteSettings.viewallLabel, by: 'chars'})"></h1>
            <h1 v-else :key="currentTitle" class="projectTitle mb-3 mb-sm-0" v-html="Splitting.html({ content: currentTitle, by: 'chars'})"></h1>
          </transition>
          <transition name="name-transition"  mode="out-in">
            <DiscoverButton high-visibility v-if="!isViewAll" :key="currentTitle" :to="{ name: 'InitiativesDetails', params: { slug: currentProjects._slug } }" class="discover m-2" />
            <!--v-if="!isViewAll && currentProjectArticleLength > 1 || currentProjectArticleLength === 0"-->
            <!--<DiscoverButton :key="currentProjects.name"  v-else-if="!isViewAll && currentProjectArticleLength === 1" :to="{ name: 'InitiativesArticle', params: { slug: currentProjects.articles[0]._slug, articleList: currentProjects.articles, projectSlug: currentProjects._slug } }" class="discover" />-->
          </transition>
    </div>
    <div class="loadingContainer mt-8">
      <div ref="loading" class="loading"></div>
    </div>
    <v-row class="navigation d-flex" justify="space-between" align-content="center" no-gutters>
      <div class="pl-5">
          <span class="totalIndex">{{`/${allProjectIndex}`}}</span>
      </div>
      <div class="command pr-5">
        <v-btn aria-label="Previous" data-cursor-target="center center" icon @click="handlePrevProjectClick"><chevron-up-icon class="chevron-icon" /></v-btn>
        <v-btn aria-label="Next" data-cursor-target="center center" icon @click="handleNextProjectClick"><chevron-down-icon class="chevron-icon" /></v-btn>
      </div>
    </v-row>
  </section>
  <section v-if="Initiatives" class="image-viewer fill-height">
    <transition name="project-image" appear mode="out-in">
      <seo-v-img class="absolute" :key="currentImage.id" :src="`/media/${currentImage.id}`" width="100%" height="100%"/>
    </transition>
  </section>
</div>
</template>

<script>
import ListInitiativeEN from '@/graphql/ListInitiative_EN.gql'
import ListInitiativeIT from '@/graphql/ListInitiative_IT.gql'
import InitiativesSideScroll from '@/molecules/InitiativesSideScroll'
import Splitting from 'splitting'
import Lottie from 'vue-lottie'
import * as CassettoAnim from '@/assets/bodymovin/Cassetto.json'
import ChevronUpIcon from '@/assets/img/chevron-up.svg'
import ChevronDownIcon from '@/assets/img/chevron-down.svg'
import DiscoverButton from '@/atoms/DiscoverButton'
import { normalizeWheel } from '@monogrid/js-utils'
import delay from 'lodash/delay'
import anime from 'animejs'

export default {
  name: 'InitiativesPage',
  components: { InitiativesSideScroll, DiscoverButton, Lottie, ChevronUpIcon, ChevronDownIcon },
  data () {
    return {
      defaultOptions: { animationData: CassettoAnim.default, loop: false },
      currentSlideIndex: 0,
      init: false,
      isViewAll: false,
      isSideScrollVisible: false,
      Splitting: Splitting,
      localizedQueries: {
        en: {
          list: ListInitiativeEN
        },
        it: {
          list: ListInitiativeIT
        }
      }
    }
  },
  mounted () {
    this.initSetup()
  },
  updated () {
    this.initSetup()
  },

  computed: {
    projects () {
      return this.Initiatives && this.Initiatives.items
    },
    allProjectIndex () {
      return `0${this.Initiatives && this.Initiatives.items.length}`
    },
    currentImageIndex () {
      return this.currentSlideIndex + 1 < 10 ? `0${this.currentSlideIndex + 1}` : this.currentSlideIndex + 1
    },
    currentProjects () {
      return this.Initiatives && this.projects[this.currentSlideIndex]
    },
    currentProjectsName () {
      return this.Initiatives && this.currentProjects.name
    },
    currentProjectArticleLength () {
      return this.Initiatives && this.currentProjects.articles.length
    },
    currentImage () {
      return this.Initiatives && this.currentProjects.image
    },
    currentTitle () {
      return this.Initiatives && this.currentProjects[`${this.$language.current}Title`]
    },
    loadingStyleObj () {
      return {
        width: `${this.loadingProgress}%`
      }
    }
  },
  methods: {
    handleNextProjectClick () {
      clearTimeout(this.scrollTimeout)
      this.loadingAnim.restart()
      this.currentSlideIndex < this.allProjectIndex - 1 ? this.currentSlideIndex += 1 : this.currentSlideIndex = 0
      this.scrollTimeout = setInterval(this.handleNextProjectClick, 10000)
    },
    handlePrevProjectClick () {
      clearTimeout(this.scrollTimeout)
      this.loadingAnim.restart()
      this.currentSlideIndex <= 0 ? this.currentSlideIndex = this.allProjectIndex - 1 : this.currentSlideIndex -= 1
      this.scrollTimeout = setInterval(this.handleNextProjectClick, 10000)
    },
    handleSideEnter () {
      if (this.$vuetify.breakpoint.xsOnly || this.$vuetify.breakpoint.mobile) return
      this.isViewAll = true
      if (this.isSideScrollVisible) return
      this.drawer.playSegments([1, 92], true)
    },
    handleSideLeave () {
      if (this.$vuetify.breakpoint.xsOnly || this.$vuetify.breakpoint.mobile) return
      this.isViewAll = false
      if (this.isSideScrollVisible) return
      this.drawer.playSegments([this.drawer.currentFrame, 1], true)
    },
    handleSideMenuClick () {
      if (this.isSideScrollVisible) {
        this.drawer.playSegments([this.drawer.currentFrame, 1], true)
        this.scrollTimeout = setInterval(this.handleNextProjectClick, 10000)
        this.loadingAnim.restart()
      } else {
        this.drawer.playSegments([this.drawer.currentFrame, 146], true)
        this.loadingAnim.pause()
        clearTimeout(this.scrollTimeout)
      }
      this.isSideScrollVisible = !this.isSideScrollVisible
    },
    handleAnimation (anim) {
      this.drawer = anim
      this.drawer.stop()
    },
    handleWheel (e) {
      if (this.isSideScrollVisible) return
      const evt = normalizeWheel(e)
      if (evt.pixelX !== 0) e.preventDefault()
      if (this.wheelTimeout) clearTimeout(this.wheelTimeout)
      if (evt.pixelX > 0) {
        this.wheelTimeout = delay(this.handlePrevProjectClick, 100)
      } else {
        this.wheelTimeout = delay(this.handleNextProjectClick, 100)
      }
    },
    initSetup () {
      if (!this.init && this.$refs.loading) {
        this.loadingAnim = anime({
          targets: this.$refs.loading,
          width: '100%',
          duration: 10000,
          easing: 'linear'
        })

        this.scrollTimeout = setInterval(
          () => {
            this.handleNextProjectClick()
          }, 10000)

        this.init = true
      }
    }
  },
  apollo: {
    Initiatives: {
      variables: { status: 'PUBLISHED', sortOn: 'priority' },
      query () {
        return this.localizedQueries[this.$language.current].list
      }
    }
  },
  metaInfo () {
    const pageName = 'initiatives'
    const imageMeta = JSON.parse(this.$root.siteSettings[`${pageName}PageShareImage`].metaData)
    return {
      // home page browser title
      title: this.$root.siteSettings[`${pageName}PageTitle`],
      meta: [
        { vmid: 'description', name: 'description', content: this.$root.siteSettings[`${pageName}PageShareDescription`] },
        { vmid: 'ogtitle', property: 'og:title', itemprop: 'name', content: `${this.$root.siteSettings[`${pageName}PageTitle`]} | ${this.$root.siteSettings.siteTitle}` },
        { vmid: 'ogdescription', property: 'og:description', content: this.$root.siteSettings[`${pageName}PageShareDescription`] },
        { vmid: 'ogimage', property: 'og:image', content: `https://${this.$root.process.env.SERVICE_TARGET_DOMAIN}/media/${this.$root.siteSettings[`${pageName}PageShareImage`].id}` },
        { vmid: 'ogimagetype', property: 'og:image:type', content: this.$root.siteSettings[`${pageName}PageShareImage`].mimeType },
        { vmid: 'ogimageheight', property: 'og:image:width', content: imageMeta['image-width'] },
        { vmid: 'ogimagewidth', property: 'og:image:height', content: imageMeta['image-height'] }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
  .absolute {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .ml-sm-32 {
    @include breakpoint('sm-and-up') {
      margin-left: 128px !important;
    }
  }

  .initiatives-page {
    overflow: hidden;
  }

  .project-image-enter-active,
  .project-image-leave-active {
    transition: top 1s cubic-bezier(0.39, 0.56, 0.16, 0.86), opacity 300ms cubic-bezier(0.39, 0.56, 0.16, 0.86);
  }

  .project-image-enter {
    opacity: 0;
    top: 20%;
  }

  .project-image-leave-to {
    opacity: 0;
    top: -20%;
    //transform: scale(0.9, 0.9) translateX(10%);
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 500ms $ease-in-out-quad;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  .image-viewer,
  .info-viewer {
    position: relative;
    width: 50%;
    max-height: 100vh;

    @include breakpoint('sm-and-down') {
      width: 100%;
      max-height: 50vh;
    }
  }

  .loadingContainer {
    width: 85%;
    border-top: 1px solid #131313;
    z-index: 2;
    position: absolute;
    bottom: 110px;
    left: 50%;
    transform: translateX(-50%);

    @include breakpoint('sm-and-down') {
      bottom: auto;
      top: 30px;
      width: 80%;
    }
  }

  .loading {
    position: relative;
    top: -1px;
    z-index: 10;
    width: 0%;
    border-top: 1px solid $c-pink;
  }

  .info-viewer {
    h1 {
      max-width: 453px;
      font-size: 6.5vh;
      /* stylelint-disable */
      &.viewAll {
        ::v-deep .char {
          position: relative;
          top: 0;
        }

        ::v-deep .word {
          overflow: hidden;
          display: inline-block;
        }
      }
      /* stylelint-enable */
    }

    .side-menu {
      position: absolute;
      width: 50px;
      top: 0;
      left: 20px;
      @include breakpoint('sm-and-down') {
        height: 50px;
        width: 100%;
        bottom: 0;
        top: auto;
        left: 0;
      }

      .handler {
        position: relative;
        display: block;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
        z-index: 40;

        /* stylelint-disable */
        div {
          @include breakpoint('sm-and-down') {
            transform: rotate(-90deg);
            position: relative;
            top: -30px;
          }
        }
        /* stylelint-enable */
      }
    }

    .side-scroll {
      width: 100%;
      top: 0;
      left: 0;
      @include breakpoint('md-only') {
        width: 170%;
      }
      @include breakpoint('sm-and-down') {
        position: absolute;
        width: 100%;
        height: 100vh;
        top: -100%;
      }
    }

    .side-scroll-enter-active,
    .side-scroll-leave-active {
      transition: transform 0.3s cubic-bezier(0.8, 0.2, 0.15, 0.76);
    }

    .side-scroll-enter,
    .side-scroll-leave-to {
      transform: translate3d(-100%, 0, 0);

      @include breakpoint('sm-and-down') {
        transform: translate3d(0, 100%, 0);
      }
    }

    span.projectName {
      font-family: $body-font-family;
      color: $c-pink;
      font-size: $font-size-root;
      display: inline-block;
    }

    .content {
      max-height: 480px;
      max-width: 500px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }

    .currentIndex {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      font-size: 38rem;
      color: $c-pink;
      font-family: $heading-font-family;
      opacity: 0.2;
      line-height: 1;
      pointer-events: none;

      @include breakpoint('sm-and-down') {
        right: 7%;
        top: 29%;
        font-size: 9rem;
      }
    }

    .current-index-enter-active,
    .current-index-leave-active {
      transition: all 1s $ease-in-out-quad;
    }

    .current-index-enter {
      opacity: 0;
      top: 60%;
    }

    .current-index-leave-to {
      opacity: 0;
      top: 40%;
    }

    .projectTitle {
      font-size: 6.5vh;
      /* stylelint-disable */
      overflow: hidden;
      padding-top: 20px;
      margin-top: -20px;

      @include breakpoint('sm-and-down') {
        font-size: 25px;
        max-width: 73%;
      }

      ::v-deep .char {
        position: relative;
        top: 0;
      }

      ::v-deep .word {
        overflow: hidden;
        display: inline-block;
        padding-top: 20px;
        margin-top: -20px;
      }
      /* stylelint-enable */
    }

    .title-transition-enter-active,
    .title-transition-leave-active {
      transition: all 1.3s $ease-in-out-quad;
      /* stylelint-disable */
      ::v-deep .char {
        transition: all 450ms $ease-in-out-quad;
        transition-delay: 0s;
        transition-delay: calc(10ms * var(--char-index));
      }
      /* stylelint-enable */
    }

    .title-transition-enter,
    .title-transition-leave-to {
      /* stylelint-disable */
      ::v-deep .char {
        opacity: 0 !important;
        top: 30px;
      }
      /* stylelint-enable */
    }

    .name-transition-enter-active {
      transition: all 1s $ease-in-out-quad;
      transition-delay: 1.1s;
    }

    .name-transition-leave-active {
      transition: all 1s $ease-in-out-quad;
    }

    .name-transition-enter,
    .name-transition-leave-to {
      opacity: 0 !important;
    }

    .navigation {
      position: absolute;
      bottom: 50px;
      left: 50%;
      transform: translateX(-50%);
      width: 90%;

      @include breakpoint('sm-and-down') {
        bottom: auto;
        top: 20px;
      }

      .totalIndex {
        font-size: 2rem;

        @include breakpoint('sm-and-down') {
          font-size: 20px;
          position: absolute;
          top: 5px;
        }
      }

    }
  }

  .chevron-icon {
    path {
      stroke: currentColor;
    }
  }
</style>
